import { bannerData } from "../../../globals/banner";
import Banner from "../../sections/common/banner";

function ContactUsPage() {
  return (
    <>
      <Banner _data={bannerData.contact} />

      <div className="section-full p-t110 p-b80 sx-bg-white sx-ourteam-outer ">
        <div className="container">
          <div className="section-content">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-12  m-b30">
                <div className="contact-info">
                  <div className="section-head left">
                    <div className="sx-head-s-title">Contact Us</div>
                    <div className="sx-head-l-title"><h2 className="sx-title">Speak with Neuron Consultancy Kenya Ltd for tailored security solutions.</h2></div>
                  </div>
                  <div className="row sx-contact-form-icon-bx">
                    <div className="col-lg-6 col-md-6 m-b30"><div className="sx-icon-bx-5"><div className="sx-media"><i className="flaticon-telephone" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title-info">Contact Phone</span><a href="tel:+254725642469" className="sx-icon-bx-title">+254 725 642 469</a></div></div></div>
                    <div className="col-lg-6 col-md-6 m-b30"><div className="sx-icon-bx-5"><div className="sx-media"><i className="flaticon-email-2" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title-info">Contact Mail</span><a href="mailto:info@neuronconsultancy.co.ke" className="sx-icon-bx-title">info@neuronconsultancy.co.ke</a><a href="mailto:protection@neuronconsultancy.co.ke" className="sx-icon-bx-title">protection@neuronconsultancy.co.ke</a></div></div></div>
                    <div className="col-lg-6 col-md-6 m-b30"><div className="sx-icon-bx-5"><div className="sx-media"><i className="flaticon-map-location" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title-info">Head Office</span><span className="sx-icon-bx-title">Ack garden, 1st Ngong Avenue, 2 Foor, wing A, Nairobi - Kenya</span></div></div></div>
                    <div className="col-lg-6 col-md-6 m-b30"><div className="sx-icon-bx-5"><div className="sx-media"><i className="flaticon-clock" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title-info">Operational Hours</span><span className="sx-icon-bx-title">Mon-Sun: 24/7 Security Support</span></div></div></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 m-b30">
                <div className="contact-home1-right">
                  <div className="contact-home-1-form sx-bg-light">
                    <h4 className="sx-title">Get In Touch</h4>
                    <form className="cons-contact-form2 form-transparent" method="post">
                      <div className="input input-animate"><input type="text" name="username" id="name" required placeholder="Your Name" /><span className="spin" /></div>
                      <div className="input input-animate"><input type="email" name="email" id="email" required placeholder="Your Email" /><span className="spin" /></div>
                      <div className="input input-animate"><input type="text" name="phone" id="Phone" required placeholder="Phone Number" /><span className="spin" /></div>
                      <div className="input textarea input-animate"><textarea name="message" id="message" required placeholder="Your Message" defaultValue={""} /><span className="spin" /></div>
                      <div className="sx-btn-center text-center p-t10"><button type="submit" className="site-button sx-btn-primary icon sx-btn-lg"><i className="fa fa-long-arrow-right" />Send Message</button></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gmap-outline map-grayscle">
        <iframe src="https://www.google.com/maps?q=Ack+Garden%2C+1st+Ngong+Avenue%2C+2+Foor%2C+wing+A%2C+Nairobi+-+Kenya&hl=en&z=16&output=embed" style={{ border: 0 }} allowFullScreen loading="lazy" title="neuron-map" />
      </div>
    </>
  );
}

export default ContactUsPage;
